import { Button, Modal } from "./ui";
import { COPY } from "../utils/copy";
import { useAuth } from "../context/AuthContext";

export function LockedNote({ show }) {
  if (!show) return null;
  return <p className="lock-note">{COPY.dayClosed}</p>;
}

export function RecordActions({
  disableEdit,
  disableDelete,
  onEdit,
  onDelete,
  className = "",
  children,
}) {
  const { isBuilder } = useAuth();
  if (!isBuilder && !children) return null;

  return (
    <div className={`row-actions ${className}`} onClick={(event) => event.stopPropagation()}>
      {children}
      {isBuilder && onEdit ? (
        <Button
          variant="ghost"
          className="btn-sm"
          disabled={disableEdit}
          title={disableEdit ? COPY.dayClosedHint : undefined}
          onClick={onEdit}
        >
          Edit
        </Button>
      ) : null}
      {isBuilder && onDelete ? (
        <Button
          variant="danger"
          className="btn-sm"
          disabled={disableDelete}
          title={disableDelete ? COPY.dayClosedHint : undefined}
          onClick={onDelete}
        >
          Delete
        </Button>
      ) : null}
    </div>
  );
}

export function ConfirmDialog({
  open,
  title,
  text,
  confirmLabel = "Delete",
  busy,
  onConfirm,
  onClose,
}) {
  return (
    <Modal
      open={open}
      title={title}
      onClose={onClose}
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="danger" disabled={busy} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <p>{text}</p>
    </Modal>
  );
}
